import { motion } from "framer-motion";

const EPI_EASE = [0.22, 1, 0.36, 1];
const EPI_PATHS = [
  "M0,18 C100,20 150,4 250,10 C350,16 400,2 500,8 C600,14 650,4 750,12 C850,18 900,6 1000,14",
  "M0,10 C100,8 150,20 250,16 C350,12 400,22 500,14 C600,6 650,18 750,10 C850,4 900,16 1000,8",
];
const EPI_INITIAL = { pathLength: 0, opacity: 0 };
const EPI_IN_VIEW = { pathLength: 1, opacity: 1 };
const EPI_VIEWPORT = { once: true };
const EPI_TRANSITION = { duration: 1.6, ease: EPI_EASE };
const HERO_CURVE_INITIAL = { pathLength: 0 };
const HERO_CURVE_ANIMATE = { pathLength: 1 };
const HERO_CURVE_TRANSITION = { duration: 2.4, ease: EPI_EASE, delay: 0.4 };

// Epidemiological curve — decorative divider rule between sections
export const EpiCurve = ({ variant = 0, className = "" }) => {
  return (
    <div className={`w-full h-7 my-2 overflow-hidden ${className}`}>
      <svg viewBox="0 0 1000 26" preserveAspectRatio="none" className="w-full h-full">
        <motion.path
          d={EPI_PATHS[variant % 2]}
          fill="none"
          stroke="var(--line)"
          strokeWidth="1.4"
          initial={EPI_INITIAL}
          whileInView={EPI_IN_VIEW}
          viewport={EPI_VIEWPORT}
          transition={EPI_TRANSITION}
        />
      </svg>
    </div>
  );
};

// Large hero epi-curve — the signature outbreak line crossing the type
export const HeroCurve = ({ className = "" }) => (
  <svg
    viewBox="0 0 1000 160"
    preserveAspectRatio="none"
    className={className}
  >
    <motion.path
      d="M0,140 C 60,138 90,120 130,118 C 180,116 210,60 260,40 C 310,20 340,70 390,80 C 440,90 470,30 520,26 C 570,22 600,90 650,100 C 700,110 730,60 780,55 C 830,50 860,100 910,105 C 950,108 980,100 1000,98"
      fill="none"
      stroke="var(--accent)"
      strokeWidth="1.6"
      initial={HERO_CURVE_INITIAL}
      animate={HERO_CURVE_ANIMATE}
      transition={HERO_CURVE_TRANSITION}
    />
  </svg>
);
